<template  v-slot:items="props">
  <v-data-table
    :headers="headers"
    :items="desserts"
    :search="search"
    sort-by="membertype"
    class="elevation-1"
  >
    <template v-slot:top>
      <v-toolbar flat color="white">
        <v-toolbar-title>Members</v-toolbar-title>
        <v-divider
          class="mx-4"
          inset
          vertical
        ></v-divider>
        {{groupname}}
        <v-spacer></v-spacer>
        <v-text-field
        v-model="search"
        append-icon="search"
        label="Search"
        single-line
        hide-details
      ></v-text-field>
        <v-dialog v-model="dialog" max-width="500px">
          <template v-slot:activator="{ on }">
            <!-- <v-btn color="primary" dark class="mb-2" v-on="on">New Item</v-btn> -->
          </template>
          <v-card>
            <v-card-title>
              <span class="headline">{{ formTitle }}</span>
            </v-card-title>

            <v-card-text>
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex xs12 sm6 md4>
                    <v-text-field v-model="editedItem.groupid" readonly label="Group ID"></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 md4>
                    <v-text-field v-model="editedItem.phonenumber" readonly label="Phone Number"></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 md4>
                    <v-select 
                    :items="items"
                    v-model="editedItem.membertype"
                    label="Role"></v-select>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
              <v-btn color="blue darken-1" text @click="save">Save</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>
    </template>
    <template v-slot:item.action="{ item }">
      <v-icon
        small
        class="mr-2"
        @click="editItem(item)"
      >
        edit
      </v-icon>
      <v-icon
        small
        @click="deleteItem(item)"
      >
        delete
      </v-icon>
    </template>
    <template v-slot:no-data>
      <v-btn color="primary" @click="initialize">Reset</v-btn>
    </template>
  </v-data-table>
</template>


<script>
  export default {
    data: () => ({
      search: '',
      dialog: false,
      items:[
          "Admin","Member"
      ],
      groupname: localStorage.groupname,
      headers: [
        {
          text: 'First Name',
          align: 'left',
          sortable: true,
          value: 'firstname',
        },
        {
          text: 'Last Name',
          value: 'lastname',
        },
        { text: 'Phone Number', value: 'phonenumber' },
        { text: 'Email', value: 'emailaddress' },
        { text: 'Gender', value: 'gender' },
        { text: 'Role', value: 'membertype' },
        { text: 'Actions', value: 'action', sortable: false },
      ],
      desserts: [],
      editedIndex: -1,
      editedItem: {
        groupid: '',
        phonenumber: 0,
        membertype: 0
      },
      defaultItem: {
        groupid: '',
        phonenumber: 0,
        membertype: 0
      },
    }),

    computed: {
      formTitle () {
        return this.editedIndex === -1 ? 'New Item' : 'Edit Item'
      },
    },

    watch: {
      dialog (val) {
        val || this.close()
      },
    },

    created () {
      this.initialize()
    },

    methods: {
      initialize () {
        
        fetch('https://shwvr4uwyh.execute-api.us-east-1.amazonaws.com/dev/getgroupmembers',{
                    method: 'post',
                    body: JSON.stringify({
                        phonenumber:localStorage.phonenumber,
                        groupid:localStorage.groupid
                    }),
                    headers: {
                     'content-type':'application/json'
                    }
                })
                .then(res => res.json())
                .then(res => {
                    console.log(res);
                    
                    if(res.responsecode == "00")
                    {
                        console.log(res);
                        this.desserts = res.members;
                        console.log('desserts');
                        console.log(this.desserts);
                    }else{
                        // this.$swal.fire(
                        //     'Errorr',
                        //     res.responsemessage,
                        //     'error'
                        // )
                    }
                    
                })
                .catch(err => console.log(err))
      },

      editItem (item) {
        this.editedIndex = this.desserts.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialog = true
      },

      deleteItem (item) {
        const index = this.desserts.indexOf(item)
        confirm('Are you sure you want to delete this item?') && this.desserts.splice(index, 1)
      },

      close () {
        this.dialog = false
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        }, 300)
      },

      save () {
        if (this.editedIndex > -1) {
          Object.assign(this.desserts[this.editedIndex], this.editedItem)
        } else {
          this.desserts.push(this.editedItem)
        }
        this.close()
      },
    },
  }
</script>